import { gql } from 'graphql-tag'

export const allTasksQuery = gql`
query {
  allTasks (
    ordering: {creationDatetime: DESC}
  ) {
    id
    creationDatetime
    expirationDatetime
    status
    pendingInfo
    resultUrl
  }
}
`
export const allDataSources = gql`
query allDataSources {
  allDataSources {
    code
    name
    resolution
    description
    boundingPolygon
  }
}
`
export const getLineStringFromGeojson = gql`
query getLineStringFromGeojson (
  $geojsonFile: Upload!
) {
  getLineStringFromGeojson(geojsonFile: $geojsonFile) {
    geojson
  }
}
`
export const getMatchingDataSourcesForBbox = gql`
query getMatchingDataSourcesForBbox (
  $south: Latitude!
  $west: Longitude!
  $north: Latitude!
  $east: Longitude!
) {
  getMatchingDataSourcesForBbox(
    box: {
      southWest: {
        longitude: $west
        latitude: $south
      },
      northEast: {
        longitude: $east
        latitude: $north
      }
    }
  ) {
    code
    name
    resolution
    description
    boundingPolygon
  }
}
`
export const allIndicators = gql`
query allIndicators (
  $dataSource: DataSourceEnum!
) {
  allIndicators(dataSource: $dataSource) {
    name
    indicators {
      code
      name
      definition
      source
      horizons {
        name
        isRef
        period
      }
    }
  }
}
`
export const scenarios = gql`
query scenarios (
  $dataSourceName: DataSourceEnum!
) {
  scenarios(dataSourceName: $dataSourceName) {
    description
    scenarios {
      name
      helpText
    }
  }
}
`
